// Integer cents keep line totals and submitted totals identical.
function cents(value) {
  if (!/^\d+(\.\d{1,2})?$/.test(String(value == null ? '' : value))) throw Error('核定金额请输入非负数字，最多两位小数')
  const n = Math.round(Number(value) * 100)
  if (!Number.isSafeInteger(n)) throw Error('核定金额超出范围')
  return n
}
function reviewTotal(review) {
  return review.kind === 'EXPENSE' && review.mode !== 'TOTAL' ? ((review.lines || []).reduce((sum, row) => sum + cents(row.approvedAmount), 0) / 100).toFixed(2) : review.mode === 'TOTAL' && (review.approvedAmount == null || String(review.approvedAmount).trim() === '') ? '—' : review.approvedAmount
}
function reviewPayload(review) {
  if (!review || !review.taskId) throw Error('请刷新审批后核对金额')
  const check = row => {
    const value = cents(row.approvedAmount), original = cents(row.originalAmount), reason = String(row.reason || '').trim()
    if (value > 99999999999) throw Error('核定金额超过允许范围')
    if (value !== original && !reason) throw Error('金额有调整时请填写原因')
    if (reason.length > 500) throw Error('调整原因最多500字')
    return { id: row.id, approvedAmount: (value / 100).toFixed(2), reason }
  }
  const lines = review.kind === 'EXPENSE' && review.mode !== 'TOTAL' ? (review.lines || []).map(check) : []
  if (review.kind === 'EXPENSE' && review.mode !== 'TOTAL' && !lines.length) throw Error('请逐条核对报销明细')
  if (review.mode === 'TOTAL') {
    if (!String(review.reason || '').trim()) throw Error('请填写核定依据，核定为0元也须说明原因')
    check({ approvedAmount: review.approvedAmount, originalAmount: 0, reason: review.reason })
  } else if (review.kind !== 'EXPENSE') check(review)
  if (cents(reviewTotal(review)) > 99999999999) throw Error('核定合计超过允许范围')
  return { taskId: review.taskId, approvedAmount: reviewTotal(review), reason: String(review.reason || '').trim(), lines }
}
module.exports = { reviewTotal, reviewPayload }
